module.exports = __webpack_public_path__ + "media/images/sales/weddingday/logo-e588a6ad020a46ee6b916dc0a5b694bf.png";